import React from 'react';

interface EditableFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  type?: 'text' | 'email' | 'password';
  autoComplete?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
}

export const EditableField: React.FC<EditableFieldProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  type = 'text',
  autoComplete,
  placeholder,
  required = false,
  error
}) => {
  return (
    <div className="space-y-1">
      {/* Label */}
      <label className="block text-xs font-semibold uppercase tracking-wide text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {/* Input Field */}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoComplete={autoComplete}
        placeholder={placeholder}
        required={required}
        className={`
          w-full rounded-md border px-2.5 py-1.5 text-sm
          focus:outline-none focus:ring-2 focus:ring-blue-500
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${error ? 'border-red-500' : 'border-gray-300'}
          ${disabled ? 'text-gray-500' : 'text-gray-900'}
        `}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${label}-error` : undefined}
      />

      {/* Error Message */}
      {error && (
        <p 
          className="mt-1 text-xs text-red-600" 
          id={`${label}-error`}
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default EditableField;
